import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserGlobalRef } from './global-ref';
import { IconsHelper } from './icons.helper';
import * as fromComponents from './components';
import * as fromDirectives from './directives';
import * as fromAngularMaterial from './material.config';
import * as fromPipes from './pipes';

/**
 * SharedModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    ...fromAngularMaterial.modules,
  ],
  declarations: [...fromComponents.components, ...fromDirectives.directives, ...fromPipes.pipes],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    ...fromAngularMaterial.modules,
    ...fromComponents.components,
    ...fromDirectives.directives,
    ...fromPipes.pipes,
  ],
  providers: [...fromAngularMaterial.providers, IconsHelper, BrowserGlobalRef, ...fromPipes.pipes],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  /**
   * constructor
   * @param {IconsHelper} iconsHelper
   */
  constructor(private iconsHelper: IconsHelper) {
    this.iconsHelper.installIcons();
  }
}
